module.exports = __webpack_public_path__ + "static/img/9.7811e21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/sp/9.png
// module id = i3Xz
// module chunks = 0